import PizzaPage from './pizza';

export default function Home(props) {
  return <PizzaPage {...props} />;
}
